import { cn } from "~/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import { HTMLAttributes } from "react";

const variants = cva("", {
    variants: {
        outline: {
            gray: ["stroke-gray-80"],
            black: ["stroke-black"],
            blue: ["stroke-blue"],
            white: ["stroke-white"],
        },
        fill: {
            gray: ["fill-gray-80"],
            black: ["fill-black"],
            blue: ["fill-blue"],
            white: ["fill-white"],
        },
        size: {
            sm: ["size-[16px]"],
            md: ["size-[18px]"],
            lg: ["size-[20px]"],
            xl: ["size-[45px]"],
        },
    },
    defaultVariants: {
        outline: "gray",
        size: "sm",
    },
});

export interface StarProps extends HTMLAttributes<SVGElement>, VariantProps<typeof variants> {}

export default function Star({ outline, fill, size, className }: StarProps) {
    const classNames = cn(variants({ outline, fill, size }), className);
    return (
        <svg
            viewBox="0 0 16 16"
            fill="none"
            className={classNames}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.49002 12.9632C8.18879 12.7962 7.82288 12.7961 7.52149 12.9627L3.72036 15.0642L4.45842 10.5398C4.50956 10.2264 4.40873 9.90721 4.18676 9.68001L1.03851 6.45755L5.33918 5.80213C5.669 5.75187 5.95203 5.54043 6.09378 5.23841L8 1.17684L9.90622 5.23841C10.048 5.54043 10.331 5.75187 10.6608 5.80213L14.9615 6.45755L11.8132 9.68001C11.5913 9.90721 11.4904 10.2264 11.5416 10.5398L12.2794 15.0629L8.49002 12.9632Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
